// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"433fc538","388":"74e05652","597":"7508762e","888":"fa1f4416"}[chunkId] + ".chunk.js";
};